var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('pre',{staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(_vm.payload))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }